import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import config from "../config";
import useBrowserStorage from "./useBrowserStorage";
import useCookie from "./useCookie";

export default function useReferralEvent() {
  const { setItem } = useBrowserStorage();
  const { setCookie, getCookie } = useCookie();
  const setReferralEvent = async (ref, formData) => {
    if (ref) {
      setItem("ref", ref, "session");
    }
    const uuidUser = getCookie("uuidUser");
    if (!uuidUser) {
      setCookie("uuidUser", uuidv4());
    }
    await axios
      .post(`${config.backendUrl}events/link`, formData, {
        withCredentials: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .catch((err) => console.log(err));
  };

  return {
    setReferralEvent,
  };
}
